import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { ProcessingBannerComponent } from 'src/app/shared/ui/processing-banner/processing-banner.component'; 


@Component({
  selector: 'app-parcs-flash-utilities',
  standalone: true,
  imports: [
    ProcessingBannerComponent,
    MatCardModule,
    MatTabsModule
  ],
  templateUrl: './parcs-flash-utilities.component.html',
  styleUrl: './parcs-flash-utilities.component.scss'
})
export class ParcsFlashUtilitiesComponent {
  isProcessing: boolean = false;
  processingMessage: string = 'Processing...';

}
